module.exports = __webpack_public_path__ + "img/tk.b2df385f.svg";